/**
 * create new message
 * @param {TopicName} topic
 * @param {Record<string, unknown>} info
 * @returns {Message}
 */
function createMessage(topic, info) {
  return { topic, info };
}

/**
 * @param {TopicName} topic
 * @param {Record<string, unknown>} [info]
 */
export default function postMessageHelper(topic, info = {}) {
  window.postMessage(createMessage(topic, info));
}

/**
 * @typedef Message
 * @property {TopicName} topic
 * @property {Record<string, unknown>} info
 */
/** @typedef {import('./TopicName').TopicName} TopicName */
